import { RootState } from "../store";
import { userActions } from "../types/userActions";
import { useAppSelector } from "../hooks";

export const useUserActionsSelector = (): userActions =>
  useAppSelector((state: RootState) => {
    return state.userActions;
  });
